export const HOST = process.env.NODE_ENV === 'production' ?`${window.location.origin}`: "http://localhost:3000";
export const URL_PREFIX = "/candidate-request";

export const FORM_STATUS = {
  0: 'черновик',
  1: 'утверждена',
  2: 'на утверждении',
  3: 'отклонена',
  4: 'отправить в PDF',
  5: 'запрошены документы',
  6: 'на рассмотрении',
  7: 'документы отправлены',
  8: 'отозвана',
  9: 'доп запрос',
  10: 'ожидает отзыва'
};

export const REQUEST_TYPE = {
  0: 'Заявка на экспертизу',
  1: 'Заявка на статус',
  2: 'Заявка на дополнительный проект',
  3: 'Заявка на статус для МТК',
};

export const FORM_LABELS = {
  0: 'primary',
  1: 'success',
  2: 'secondary',
  3: 'warning',
  4: 'secondary',
  5: 'secondary',
  6: 'secondary',
  7: 'secondary',
  8: 'warning',
  9: 'secondary',
  10: 'secondary'
};

export const getFormTitle = ({ process_id }) => 'Заявка №' + process_id;
export const getFormSubtitle = (forms, values) => {
  const dictionaryRequestType = ['Экспертиза проекта', 'Статус участника', 'Дополнительный проект', 'Заявка на статус для МТК'];
  const requestType = values.find(item => item.controlid === 'RequestType');
  if(requestType && dictionaryRequestType[+requestType.value]) {
    return dictionaryRequestType[+requestType.value];
  }
  return forms.typeForm || '';
};

export const FORM_BUTTONS = {
  send: 'Отправить',
  withdraw: 'Отозвать'
};

export const PAGINATION = {
  page: 1,
  pagesize: 20,
  total: 0,
};
